import type { TableColumn } from '@/components/alerts/types'
import FavSymbolEditCell from '@/components/fav-symbols/FavSymbolEditCell.vue'
import type { FavSymbolResponse } from '@/services/fav-symbols-v2-service/types'
import { markRaw } from 'vue'

export const getFavSymbolsColumns = (): TableColumn[] => {
  return [
    {
      field: 'asset',
      width: '120px',
      header: 'table.asset',
      class: 'text-center',
      inner: 'span',
      innerProps: {
        class: 'pit',
      },
    },
    {
      field: 'market_type',
      width: '110px',
      header: 'marketType',
      class: 'text-center font-bold hidden lg:table-cell',
      inner: 'span',
      innerProps: {
        class: 'pit',
      },
    },
    {
      field: 'ex_buy.name',
      width: '110px',
      header: 'table.exBuy',
      class: 'text-center font-bold',
      inner: 'span',
      innerProps: {
        class: 'pit success',
      },
    },
    {
      field: 'ex_sell.name',
      width: '110px',
      header: 'table.exSell',
      class: 'text-center font-bold',
      inner: 'span',
      innerProps: {
        class: 'pit error',
      },
    },

    {
      dynamic: true,
      field: '',
      width: '50px',
      header: '',
      class: 'text-center collapser-class',
      inner: markRaw(FavSymbolEditCell),
      innerPropsGenerator: (data: object) => {
        return {
          data: data as FavSymbolResponse,
        }
      },
    },
  ]
}
